import { render, staticRenderFns } from "./ChangeType.vue?vue&type=template&id=b6e85fec&scoped=true"
import script from "./ChangeType.vue?vue&type=script&lang=js"
export * from "./ChangeType.vue?vue&type=script&lang=js"
import style0 from "./ChangeType.vue?vue&type=style&index=0&id=b6e85fec&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e85fec",
  null
  
)

export default component.exports